export function formatToISO(date) {
    if (!date) {
        return '';
    }

    let input = date;
    if (typeof date === 'string' && /^\d+$/.test(date)) {
        input = Number(date);
    }

    return spacetime(input).format('iso').substring(0, 10);
}

export function arabicDigits(text) {
    const locale = document.documentElement.lang || window.currentLocale;

    if (locale !== 'ar') {
        return text;
    }

    const map = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return text.replace(/\d/g, (d) => map[d]);
}

export function decodeHtmlEntity(str) {
    const el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
}

export const CELL_MAX_LENGTH_MOBILE = 5;
export const CELL_MAX_LENGTH_DESKTOP = 8;

export function getCellMaxLength() {
    return window.innerWidth < 768 ? CELL_MAX_LENGTH_MOBILE : CELL_MAX_LENGTH_DESKTOP;
}

export function parseCurrencyPosition(displayPrice) {
    const dp = displayPrice ? displayPrice.trim() : '';
    return {
        isCurrencyAtStart: dp ? !/^\d/.test(dp) : true,
        hasSpace: dp ? /\d\s+[^\d]|[^\d]\s+\d/.test(dp) : false,
    };
}

export function attachCurrency(priceStr, currencyCode, displayPrice) {
    const currency = decodeHtmlEntity(currencyCode);
    const { isCurrencyAtStart, hasSpace } = parseCurrencyPosition(displayPrice);
    const space = hasSpace ? ' ' : '';
    return isCurrencyAtStart ? `${currency}${space}${priceStr}` : `${priceStr}${space}${currency}`;
}

export function priceFitsWithCurrency(priceLength, currencyEntity, hasSpace, maxLength = CELL_MAX_LENGTH_DESKTOP) {
    const decoded = decodeHtmlEntity(currencyEntity);
    return decoded.length + (hasSpace ? 1 : 0) + priceLength <= maxLength;
}

export function getCompactPrice(roundedPrice) {
    const locale = document.documentElement.lang || window.currentLocale;
    if (roundedPrice >= 1000000) {
        const m = Math.round(roundedPrice / 100000) / 10;
        const numStr = m % 1 === 0 ? m.toFixed(0) : m.toFixed(1);
        const suffix = locale === 'ar' ? 'م' : 'M';
        return arabicDigits(numStr) + suffix;
    }
    if (locale === 'en' && roundedPrice >= 1000) {
        const k = Math.round(roundedPrice / 100) / 10;
        return (k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)) + 'K';
    }
    return arabicDigits(roundedPrice.toString());
}



export function formatPrice(dayData, maxLength = CELL_MAX_LENGTH_DESKTOP, showCurrency = null) {
    if (!dayData.rawPrice) return '';

    const locale = document.documentElement.lang || window.currentLocale || 'en';
    const compact = getCompactPrice(Math.round(dayData.rawPrice));
    const isCompacted = /[KMم]/.test(compact);

    if (!dayData.displayPrice) {
        return isCompacted ? compact : arabicDigits(new Intl.NumberFormat(locale).format(Math.round(dayData.rawPrice)));
    }

    const displayPrice = dayData.displayPrice.trim();
    const decodedDisplayPrice = decodeHtmlEntity(displayPrice);
    const { isCurrencyAtStart, hasSpace } = parseCurrencyPosition(displayPrice);
    const currencyEntity = dayData.currencyCode || (isCurrencyAtStart
        ? (decodedDisplayPrice.match(/^([^\d]+)/) || ['', ''])[1].trim()
        : (decodedDisplayPrice.match(/([^\d]+)$/) || ['', ''])[1].trim());

    if (isCompacted) {
        const display = showCurrency !== null ? showCurrency : priceFitsWithCurrency(compact.length, currencyEntity, hasSpace, maxLength);
        if (!display) return compact;
        return attachCurrency(compact, currencyEntity, displayPrice);
    }

    // Not compacted: decimals+currency if it fits, else rounded+currency, else rounded only
    const formattedRounded = arabicDigits(new Intl.NumberFormat(locale).format(Math.round(dayData.rawPrice)));

    const decimalFits = showCurrency !== null ? showCurrency : priceFitsWithCurrency(decodedDisplayPrice.replace(/[^\d.,]/g, '').length, currencyEntity, hasSpace, maxLength);
    if (decimalFits) return arabicDigits(displayPrice);

    const roundedFits = priceFitsWithCurrency(formattedRounded.length, currencyEntity, hasSpace, maxLength);
    if (roundedFits) return attachCurrency(formattedRounded, currencyEntity, displayPrice);

    return formattedRounded;
}
